import { Element, ElementType, Rect } from '@ritabygglov/core';
import { screenPx } from '../../helpers/handleScale';
import { EDGE_STRIP_THICKNESS_PX } from '../../helpers/handleTokens';
import { makeResizeCursorUrl } from '../../helpers/utility';
import { getCornerCoords } from './Elements';

const MIN_SCREEN_SIZE = 20;

const EDGE_SUPPORTED_TYPES: ElementType[] = [
  ElementType.Rect,
  ElementType.Fixture,
  ElementType.Triangle,
  ElementType.Trapezoid,
  ElementType.Angle,
  ElementType.Text,
];

const getEdgeCursor = (isHorizontalEdge: boolean, rotate: number): string => {
  const perpAngle = isHorizontalEdge ? rotate + 90 : rotate;
  return makeResizeCursorUrl(perpAngle);
};

export const RenderEdgeSelectors = (e: Element, scale: number) => {
  if (!EDGE_SUPPORTED_TYPES.includes(e.type)) return null;

  const el = e as Rect;
  const screenW = Math.abs(el.width) / scale;
  const screenH = Math.abs(el.height) / scale;
  if (screenW < MIN_SCREEN_SIZE || screenH < MIN_SCREEN_SIZE) return null;

  const thickness = screenPx(EDGE_STRIP_THICKNESS_PX, scale);
  const half = thickness / 2;

  const { tL, tR, bL } = getCornerCoords(e);
  const rectLeft = Math.min(tL.x, tR.x);
  const rectTop = Math.min(tL.y, bL.y);
  const w = Math.abs(tR.x - tL.x);
  const h = Math.abs(bL.y - tL.y);

  const topBottomCursor = getEdgeCursor(true, e.rotate);
  const leftRightCursor = getEdgeCursor(false, e.rotate);

  return (
    <>
      <rect
        id={`${e.id}-resize-top`}
        x={rectLeft}
        y={rectTop - half}
        width={w}
        height={thickness}
        fill="transparent"
        style={{ cursor: topBottomCursor }}
        pointerEvents="all"
      />
      <rect
        id={`${e.id}-resize-bottom`}
        x={rectLeft}
        y={rectTop + h - half}
        width={w}
        height={thickness}
        fill="transparent"
        style={{ cursor: topBottomCursor }}
        pointerEvents="all"
      />
      <rect
        id={`${e.id}-resize-left`}
        x={rectLeft - half}
        y={rectTop}
        width={thickness}
        height={h}
        fill="transparent"
        style={{ cursor: leftRightCursor }}
        pointerEvents="all"
      />
      <rect
        id={`${e.id}-resize-right`}
        x={rectLeft + w - half}
        y={rectTop}
        width={thickness}
        height={h}
        fill="transparent"
        style={{ cursor: leftRightCursor }}
        pointerEvents="all"
      />
    </>
  );
};
